import { makeHttpRequest } from "@/shared";

export const deleteRent = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
